module.exports = __webpack_public_path__ + "img/eg-5.81bd2e8d.jpg";